import { IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

interface ExportButtonProps {
  noun: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export function ExportButton(props: ExportButtonProps) {
  const { noun, onClick } = props;

  return (
    <IconButton color='primary' aria-label={`export ${noun}`} title={`Export ${noun}`} onClick={onClick}>
      <DownloadIcon />
    </IconButton>
  );
}
